var n=function(n){return Object.entries(n).filter((function(n){n[0];var r=n[1];return Boolean(r)})).map((function(n){var r=n[0],e=n[1];return"boolean"==typeof e?r:e})).join(" ")};export{n as mergeData};
//# sourceMappingURL=ui.mjs.map
